import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Pipe({
  name: 'amount',
})
export class AmountPipe implements PipeTransform {
  private decimalPipe: PipeTransform;

  constructor(@Inject(LOCALE_ID) private readonly locale: string) {
    this.decimalPipe = new DecimalPipe(locale);
  }
  transform(value: any, digits?: string, skipNumberFormatting = false): any {
    const checkedValue = isNaN(Number(value)) ? value : Number(value) / 100;

    if (skipNumberFormatting) {
      return checkedValue;
    } else {
      return this.decimalPipe.transform(checkedValue, digits);
    }
  }
}
